module.exports = __webpack_public_path__ + "img/ie.798a56e0.svg";